import GiftBoxApi from '@apis/gift/GiftBoxApi';
import giftBoxQueries from '@apis/queries/giftBoxQueries';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getFlattenPageResponse, getIsBlank, getNextPageParam } from '@utils/slice';

const PAGE_SIZE = 20;

function useReceivedGiftBoxes(availableOnly: boolean) {
    const params = {
        size: PAGE_SIZE,
        ...(availableOnly ? { available: true } : {}),
    };
    const queryInfo = useInfiniteQuery({
        queryKey: giftBoxQueries.received(params).queryKey,
        queryFn: ({ pageParam }) => GiftBoxApi.getReceivedGiftBoxes({
            ...params,
            page: pageParam,
        }),
        initialPageParam: 0,
        getNextPageParam,
    });

    return {
        ...queryInfo,
        gifts: getFlattenPageResponse(queryInfo) ?? [],
        isEmpty: getIsBlank(queryInfo),
    };
}

export default useReceivedGiftBoxes;
